import React from "react";

const Error404 = () => {
  return <h2>Страница не найдена</h2>;
};

export default Error404;
